import { createComponent } from "@lit/react";
import React from "react";
import { APP_ICON_TAG, AppIcon as AppIconWc } from "./components/AppIcon.js";
import { APP_SWITCHER_TAG, AppSwitcher as AppSwitcherWc } from "./components/AppSwitcher.js";
import { GLOBAL_NAV_TAG, GlobalNav as GlobalNavWc } from "./components/GlobalNav.js";
import { HELP_MENU_TAG, HelpMenu as HelpMenuWc } from "./components/HelpMenu.js";
import { NAV_LINK_TAG, NavLink as AppSwitcherLinkWc } from "./components/NavItems/NavLink.js";
import { NAV_SECTION_TAG, NavSection as AppSwitcherSectionWc, } from "./components/NavItems/NavSection.js";
import { NAV_TREE_TAG, NavTree as AppSwitcherTreeWc } from "./components/NavItems/NavTree.js";
import { NAV_TREE_NODE_TAG, NavTreeNode as AppSwitcherTreeNodeWc, } from "./components/NavItems/NavTreeNode.js";
import { ORG_SWITCHER_TAG, OrgSwitcher as OrgSwitcherWc } from "./components/OrgSwitcher.js";
import { SHORTCUTS_PANEL_TAG, ShortcutsPanel as ShortcutsPanelWc, } from "./components/ShortcutsPanel.js";
import { SIGN_IN_BUTTON_TAG, SignInButton as SignInButtonWc } from "./components/SignInButton.js";
import { USER_MENU_TAG, UserMenu as UserMenuWc } from "./components/UserMenu.js";
import { CHANGE_ORG_EVENT_NAME, CLOSE_EVENT_NAME, OPEN_EVENT_NAME, OPEN_SECTION_EVENT_NAME, TOGGLE_MODAL_EVENT_NAME, } from "./configuration/constants.js";
const getOriginalElement = (tagName, fallback) => {
    return (customElements.get(tagName) ?? fallback);
};
export const GlobalNav = createComponent({
    react: React,
    tagName: GLOBAL_NAV_TAG,
    elementClass: getOriginalElement(GLOBAL_NAV_TAG, GlobalNavWc),
    events: {
        onModalToggle: TOGGLE_MODAL_EVENT_NAME,
    },
});
export const AppSwitcher = createComponent({
    react: React,
    tagName: APP_SWITCHER_TAG,
    elementClass: getOriginalElement(APP_SWITCHER_TAG, AppSwitcherWc),
    events: {
        onSectionOpen: OPEN_SECTION_EVENT_NAME,
    },
});
export const NavLink = createComponent({
    react: React,
    tagName: NAV_LINK_TAG,
    elementClass: getOriginalElement(NAV_LINK_TAG, AppSwitcherLinkWc),
});
export const NavSection = createComponent({
    react: React,
    tagName: NAV_SECTION_TAG,
    elementClass: getOriginalElement(NAV_SECTION_TAG, AppSwitcherSectionWc),
    events: {
        onOpen: OPEN_EVENT_NAME,
        onClose: CLOSE_EVENT_NAME,
    },
});
export const NavTree = createComponent({
    react: React,
    tagName: NAV_TREE_TAG,
    elementClass: getOriginalElement(NAV_TREE_TAG, AppSwitcherTreeWc),
});
export const NavTreeNode = createComponent({
    react: React,
    tagName: NAV_TREE_NODE_TAG,
    elementClass: getOriginalElement(NAV_TREE_NODE_TAG, AppSwitcherTreeNodeWc),
});
export const HelpMenu = createComponent({
    react: React,
    tagName: HELP_MENU_TAG,
    elementClass: getOriginalElement(HELP_MENU_TAG, HelpMenuWc),
    events: {
        onModalToggle: TOGGLE_MODAL_EVENT_NAME,
    },
});
export const OrgSwitcher = createComponent({
    react: React,
    tagName: ORG_SWITCHER_TAG,
    elementClass: getOriginalElement(ORG_SWITCHER_TAG, OrgSwitcherWc),
    events: {
        onOrganizationChange: CHANGE_ORG_EVENT_NAME,
        onModalToggle: TOGGLE_MODAL_EVENT_NAME,
    },
});
export const ShortcutsPanel = createComponent({
    react: React,
    tagName: SHORTCUTS_PANEL_TAG,
    elementClass: getOriginalElement(SHORTCUTS_PANEL_TAG, ShortcutsPanelWc),
    events: {
        onModalToggle: TOGGLE_MODAL_EVENT_NAME,
    },
});
export const SignInButton = createComponent({
    react: React,
    tagName: SIGN_IN_BUTTON_TAG,
    elementClass: getOriginalElement(SIGN_IN_BUTTON_TAG, SignInButtonWc),
});
export const UserMenu = createComponent({
    react: React,
    tagName: USER_MENU_TAG,
    elementClass: getOriginalElement(USER_MENU_TAG, UserMenuWc),
    events: {
        onModalToggle: TOGGLE_MODAL_EVENT_NAME,
    },
});
export const AppIcon = createComponent({
    react: React,
    tagName: APP_ICON_TAG,
    elementClass: getOriginalElement(APP_ICON_TAG, AppIconWc),
});
